import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useAxios } from '../../utils/hook/useAxios';

const METHODS = [
  {
    value: '0',
    icon: 'people-outline',
    title: 'Rencontrer les invités en personne',
    desc: 'Choisissez cette option si vous prévoyez de rencontrer directement les invités pour la remise des clés.',
  },
  {
    value: '1',
    icon: 'lock-closed-outline',
    title: 'Utiliser une boîte à clé sécurisée',
    desc: 'Choisissez cette option si vous prévoyez de laisser les clés dans une boîte sécurisée pour que les invités puissent les récupérer.',
    disabled: true,
  },
  {
    value: '2',
    icon: 'phone-portrait-outline',
    title: 'Déverrouillage à distance',
    desc: "Choisissez cette option si vous prévoyez de déverrouiller la porte à distance pour permettre l'accès aux invités.",
    disabled: true,
  },
  {
    value: '3',
    icon: 'ellipsis-horizontal-circle-outline',
    title: 'Autre méthode de prise en charge',
    desc: 'Choisissez cette option si vous avez une méthode de prise en charge différente de celles proposées ci-dessus.',
    disabled: true,
  },
];

function LocationModeCar() {
  const { voitureId, annonceId } = useParams();

  const [PriseEnChargeMethod, setPriseEnChargeMethod] = useState('0');

  const axios = useAxios();
  function handleModifierLieuxPriseEnCharge() {
    let fetchReviews = async () => {
      try {
        const response = await axios.put('/deliverylocation/' + annonceId, {
          PriseEnChargeMethod: PriseEnChargeMethod,
        });

        if (response.data) {
          toast.success('Lieu de prise en charge  modifié  pour votre annonce');
          window.location.href = '/availabilities-car/' + voitureId;
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }

  return (
    <main className="mc-home mc-form-page">
      <div className="mc-form-shell mc-form-shell--narrow">
        <div className="mc-stepper">
          <div className="mc-stepper-top">
            <span>Inscrire ma voiture</span>
            <span>70 %</span>
          </div>
          <div
            className="mc-stepper-bar"
            role="progressbar"
            aria-label="Progression de l'inscription"
            aria-valuenow="70"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div className="mc-stepper-fill" style={{ width: '70%' }}></div>
          </div>
        </div>

        <section className="mc-form-card">
          <span className="mc-section-kicker">PRISE EN CHARGE</span>
          <h1 className="mc-form-title">Comment louer votre voiture dans cette annonce ?</h1>
          <p className="mc-form-subtitle">Choisissez comment vos locataires récupèrent les clés.</p>

          <div className="mc-field">
            <div
              role="radiogroup"
              aria-label="Méthode de prise en charge"
              className="mc-policy-list"
            >
              {METHODS.map(({ value, icon, title, desc, disabled }) => (
                <label className="mc-policy" htmlFor={`method-${value}`} key={value}>
                  <input
                    type="radio"
                    name="priseEnChargeMethod"
                    id={`method-${value}`}
                    value={value}
                    checked={PriseEnChargeMethod === value}
                    disabled={disabled}
                    onChange={(e) => setPriseEnChargeMethod(e.target.value)}
                  />
                  <span className="mc-policy-body">
                    <strong className="mc-method-title">
                      <ion-icon name={icon}></ion-icon>
                      {title}
                      {disabled && <em className="mc-soon">Bientôt disponible</em>}
                    </strong>
                    <small>{desc}</small>
                  </span>
                </label>
              ))}
            </div>
          </div>

          <div className="mc-form-actions">
            <span></span>
            <button
              type="button"
              className="mc-btn mc-btn--primary"
              onClick={handleModifierLieuxPriseEnCharge}
            >
              Confirmer
              <ion-icon name="arrow-forward-outline"></ion-icon>
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}

export default LocationModeCar;
